@if (label) {
    <label
        [class.text-muted]="status === 'muted'"
        [attr.for]="labelForId || ''"
    >
        @let requiredHtml =
            required
                ? '<sup><wdx-icon icon="asterisk" class="ms-1 text-danger" data-cy="wdx-label-required-asterisk"></wdx-icon></sup><sup><i data-cy="wdx-label-required-asterisk" class="fa-asterisk fal text-danger"></i></sup>'
                : '';
        @let content = label + requiredHtml | markdownToHtml | safeHtml;

        <span [innerHtml]="content"></span>
    </label>
}
